/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetListPaymentTermsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetListPaymentTermsQuery = {
  __typename?: 'Query',
  listPaymentTerms?: Array<{
    __typename?: 'PaymentTerm',
    id: number,
    days: number,
    externalReference?: string | null,
    isDefault: boolean
  }> | null
};


export const GetListPaymentTermsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListPaymentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPaymentTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentTerm"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentTerm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentTerm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<GetListPaymentTermsQuery, GetListPaymentTermsQueryVariables>;